"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryEvents = void 0;
/**
 * All the event schemas in this file must be registered in self-service-analytics.tsi.lan:
 * https://mytableau.tableaucorp.com/pages/viewpage.action?spaceKey=devprocess&title=Getting+Started+with+Telemetry+@+Tableau#GettingStartedwithTelemetry@Tableau-create-event-schema
 */
var TelemetryEvents;
(function (TelemetryEvents) {
    TelemetryEvents["DataDisplayedInSharedDialog"] = "dataDisplayedInSharedDialog";
})(TelemetryEvents = exports.TelemetryEvents || (exports.TelemetryEvents = {}));
//# sourceMappingURL=TelemetryEvents.js.map